import * as React from "react";
import type { SVGProps } from "react";
const SvgBookIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="book_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M277.333 170.667h533.334V640H277.333c-22.912 0-44.586 5.12-64 14.379V224c0-12.587 5.547-25.728 17.11-36.181a70.357 70.357 0 0 1 46.89-17.152zM128 224v576c0 38.315 16.939 74.027 45.355 99.584 28.288 25.43 65.706 39.083 103.978 39.083h533.334A85.333 85.333 0 0 0 896 853.333V170.667a85.333 85.333 0 0 0-85.333-85.334H277.333c-38.229 0-75.69 13.654-103.978 39.083A134.059 134.059 0 0 0 128 224zm149.333 501.333h533.334v128H277.333c-18.346 0-35.157-6.613-46.89-17.152A48.768 48.768 0 0 1 213.333 800v-10.667a64 64 0 0 1 64-64zm128-469.333a42.667 42.667 0 0 0 0 85.333h213.334a42.667 42.667 0 1 0 0-85.333H405.333z"
    />
  </svg>
);
export default SvgBookIcon;
